import './index.css';
import './styles/sketchy.css';
import './i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { DesignProvider } from './contexts/DesignContext';
import { logInfo, logError } from './services/logtail';
import { registerServiceWorker } from './sw-register';
import { startAuthStore } from './auth/authStore';
import './services/apiClient';

// Start the single auth bootstrap before render so route loaders can await it.
startAuthStore();

// Set environment variable on window for HTML script access
if (typeof window !== 'undefined') {
  (window as any).VITE_ENV = import.meta.env.VITE_ENV;
}

// Register service worker for PWA
registerServiceWorker();

// Log app startup
logInfo('Cassette app starting up');

// Global error handlers to capture uncaught errors and unhandled promise rejections
window.addEventListener('error', (event) => {
  try {
    logError('Unhandled error', {
      message: event.message,
      filename: (event as ErrorEvent).filename,
      lineno: (event as ErrorEvent).lineno,
      colno: (event as ErrorEvent).colno,
      error: (event as ErrorEvent).error ? String((event as ErrorEvent).error) : undefined,
    });
  } catch {}
});

window.addEventListener('unhandledrejection', (event) => {
  try {
    const reason = (event as PromiseRejectionEvent).reason;
    logError('Unhandled promise rejection', {
      reason: reason instanceof Error ? reason.message : String(reason),
      stack: reason && reason.stack ? String(reason.stack) : undefined,
    });
  } catch {}
});

// Stop the inline boot loader before React replaces #root.
if (typeof window !== 'undefined' && typeof (window as Window & { __stopBootLoader?: () => void }).__stopBootLoader === 'function') {
  (window as Window & { __stopBootLoader?: () => void }).__stopBootLoader!();
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ThemeProvider>
      <DesignProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </DesignProvider>
    </ThemeProvider>
  </React.StrictMode>
);